export const adjustFontSizeByHeight = async (elementRef, maxFontSize, maxHeight, minFontSize = 10, adjustLineHeight = true) => {
  const element = elementRef.current;

  if (!element) return { fontSize: maxFontSize, lineHeight: getLineHeight(maxFontSize) };

  await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

  let fontSize = maxFontSize;
  element.style.fontSize = `${fontSize}px`;
  if (adjustLineHeight) {
    element.style.lineHeight = `${getLineHeight(fontSize)}px`;
  }

  setTimeout(() => {
    while (element.scrollHeight > maxHeight && fontSize > minFontSize) {

      fontSize -= 1;
      element.style.fontSize = `${fontSize}px`;
      if (adjustLineHeight) {
        element.style.lineHeight = `${getLineHeight(fontSize)}px`;
      }



    }
  }, 200);

  return { fontSize, lineHeight: getLineHeight(fontSize) };
};


const getLineHeight = (fontSize) => {
  // if (fontSize > 28) return fontSize * 0.9;
  if (fontSize > 22) return fontSize * 1.1;
  return fontSize * 1.2;
};




export const adjustFontSizeByWidth = async (elementRef, maxFontSize, maxWidth, shouldWrap = false, minFontSize = 10) => {
  const element = elementRef.current;


  if (!element) return { fontSize: maxFontSize, lineHeight: maxFontSize * 1.2 };
await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

  if (element.offsetWidth === 0) {
    return { fontSize: maxFontSize, lineHeight: maxFontSize * 1.2 };
  }

  if (shouldWrap) {
    element.style.whiteSpace = "normal";
    element.style.wordBreak = "break-word";
  }


  let fontSize = maxFontSize;
  element.style.fontSize = `${fontSize}px`;
  element.style.lineHeight = `${getLineHeight(fontSize)}px`;

  setTimeout(() => {
    while (element.offsetWidth > maxWidth && fontSize > minFontSize) {

      fontSize -= 1;
      element.style.fontSize = `${fontSize}px`;
      element.style.lineHeight = `${getLineHeight(fontSize)}px`;

      element.offsetWidth;

      
    }
  }, 200);

  return { fontSize, lineHeight: getLineHeight(fontSize) };
};



